import { AfterViewInit, Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { GoogleMapsApiLoaderService } from '../../services/google-maps-api-loader.service';
import { texts } from './editor-location-list.texts';

@Component({
    selector: 'sc-editor-location-list',
    templateUrl: './editor-location-list.component.html',
    styleUrls: ['./editor-location-list.component.scss'],
    standalone: false
})
export class EditorLocationListComponent implements AfterViewInit {

  @Input()
  language: 'de' | 'en' = 'de';

  texts = texts;

  @Input()
  locations: any = [];

  @Output()
  locationsChange = new EventEmitter<any>();

  @ViewChild("search")
  searchElementRef: ElementRef<HTMLInputElement>;

  constructor(private mapsApiLoader: GoogleMapsApiLoaderService, private ngZone: NgZone) { }

  ngAfterViewInit() {
    this.loadGoogleMap();
  }

  loadGoogleMap() {
    //load Places Autocomplete
    this.mapsApiLoader.load().then(() => {
      var searchInput = this.searchElementRef.nativeElement;
      console.log(searchInput);

      const germanyBounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(47.2701, 5.8663),
        new google.maps.LatLng(55.0991, 15.0419)
      );

      const options: google.maps.places.AutocompleteOptions = {
        bounds: germanyBounds,
        strictBounds: false,
        fields: ['address_components', 'geometry', 'name'],
        types: ['(cities)']
      };

      var autocomplete = new google.maps.places.Autocomplete(searchInput, options);
      console.log(autocomplete)

      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {

          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          var city = '';
          var street = '';
          var zip = '';
          var number = '';
          var country = '';

          place.address_components.forEach(c => {
            if (c.types.indexOf('locality') >= 0) city = c.long_name;
            if (c.types.indexOf('route') >= 0) street = c.long_name;
            if (c.types.indexOf('postal_code') >= 0) zip = c.long_name;
            if (c.types.indexOf('street_number') >= 0) number = c.long_name;
            if (c.types.indexOf('country') >= 0) country = c.long_name;
          })

          var location = {
            Latitude: place.geometry.location.lat(),
            Longitude: place.geometry.location.lng(),
            Zip: zip,
            City: city,
            Street: street,
            Number: number,
            Country: country,
            Radius: 0
          };

          if (!this.locations) this.locations = [];
          this.locations.push(location);
          this.locationsChange.emit(this.locations);

          this.searchElementRef.nativeElement.value = '';
        });
      });
    });
  }

  removeLocation(location) {
    var i = this.locations.indexOf(location);
    this.locations.splice(i, 1);
    this.locationsChange.emit(this.locations);
  }
}
